import React from "react";

import { Button } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";

import { ILayoutProps } from "@/types";

/**
 * Chrome for the first-run setup: no menu (there is nothing to navigate
 * to yet), just the logo and a way out. The content is centred and
 * scrolls on its own so a long step still reaches its buttons.
 */
export const OnboardingLayout: React.FC<ILayoutProps> = ({ children }) => {
	const navigate = useNavigate();
	const { logout } = useAuth();
	return (
		<div className="flex h-full flex-col overflow-auto bg-[var(--amp-color-surface)]">
			<header className="flex items-center justify-between gap-4 p-8 pb-0">
				<div
					className="flex items-center gap-4"
					role="button"
					tabIndex={0}
					onClick={() => navigate("/")}
					onKeyDown={(e) => e.key === "Enter" && navigate("/")}
				>
					<img
						src="/assets/logo.svg"
						alt="Chronos"
						className="pointer-events-none h-8 w-8"
					/>
					<div className="text-2xl tracking-wider whitespace-nowrap max-sm:hidden">
						C H R O N O S
					</div>
				</div>
				<Button variant="ghost" picto="logout" onClick={logout}>
					{t("auth.logout")}
				</Button>
			</header>
			<main className="flex flex-1 items-start justify-center p-4 pt-8 sm:p-8 sm:pt-14">
				{typeof children === "function" ? children() : children}
			</main>
		</div>
	);
};
